import { render } from "./PressSection.vue?vue&type=template&id=7d9615ee"
import script from "./PressSection.vue?vue&type=script&lang=js"
export * from "./PressSection.vue?vue&type=script&lang=js"

import exportComponent from "/Users/florianroscher/Sites/simtschuk-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__